export var HeaderPanel;
(function (HeaderPanel) {
    HeaderPanel["ProfilePanel"] = "ProfilePanel";
    HeaderPanel["SettingsPanel"] = "SettingsPanel";
    HeaderPanel["HelpPanel"] = "HelpPanel";
    HeaderPanel["NotificationPanel"] = "NotificationPanel";
    HeaderPanel["FeedbackPanel"] = "FeedbackPanel";
})(HeaderPanel || (HeaderPanel = {}));
//# sourceMappingURL=Header.types.js.map